// GES-405 PDF UX — paper geometry for the document preview AND the PDF/print requests. The table and getDocPaper() mirror the API's
// lib/docPaper.js (single definition per side, keep them identical). getDocPaper(docType) = the default paper for EVERY document type
// today (A4 portrait, 14/15/18/15 mm); the document template/settings work will make it read the saved per-type setting.
export const PAGE_SIZES = { A3: { w: 297, h: 420 }, A4: { w: 210, h: 297 }, A5: { w: 148, h: 210 }, Letter: { w: 215.9, h: 279.4 }, Legal: { w: 215.9, h: 355.6 } };
export const DEFAULT_MARGINS = { top: 14, right: 15, bottom: 18, left: 15 };

export const getDocPaper = (docType) => ({ pageSize: 'A4', orientation: 'portrait', margins: { ...DEFAULT_MARGINS } }); // eslint-disable-line no-unused-vars

export function paperGeometry(paper) {
  const p = paper && PAGE_SIZES[paper.pageSize] ? paper : getDocPaper();
  const s = PAGE_SIZES[p.pageSize]; const land = p.orientation === 'landscape'; const m = { ...DEFAULT_MARGINS, ...(p.margins || {}) };
  const widthMm = land ? s.h : s.w; const heightMm = land ? s.w : s.h;
  return { widthMm, heightMm, margins: m, contentHeightMm: Math.round((heightMm - m.top - m.bottom) * 10) / 10 };
}

// CSS custom properties the preview sheet derives its size from (documents.css reads --paper-*).
export function paperCssVars(paper) {
  const g = paperGeometry(paper);
  return { '--paper-w': `${g.widthMm}mm`, '--paper-h': `${g.heightMm}mm`, '--paper-content-h': `${g.contentHeightMm}mm`,
    '--m-top': `${g.margins.top}mm`, '--m-right': `${g.margins.right}mm`, '--m-bottom': `${g.margins.bottom}mm`, '--m-left': `${g.margins.left}mm` };
}
